import { render, staticRenderFns } from "./GoldenStandardView.vue?vue&type=template&id=72ffe15b&scoped=true"
import script from "./GoldenStandardView.vue?vue&type=script&lang=js"
export * from "./GoldenStandardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ffe15b",
  null
  
)

export default component.exports